export default __webpack_public_path__ + "static/media/Group 130.d413c1e2.png";